export default __webpack_public_path__ + "static/media/Cyberpunk2077-black.f1724058.png";